var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgUpdateLocation = function SvgUpdateLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    width: 32
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16z",
    fill: "#db5437"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16z",
    fill: "#fff",
    fillOpacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.667a5.83 5.83 0 00-5.833 5.833c0 4.375 5.833 10.834 5.833 10.834s5.833-6.459 5.833-10.834A5.829 5.829 0 0016 7.667zm0 7.917a2.084 2.084 0 11.002-4.169A2.084 2.084 0 0116 15.584z",
    fill: "#db5437"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.667a5.83 5.83 0 00-5.833 5.833c0 4.375 5.833 10.834 5.833 10.834s5.833-6.459 5.833-10.834A5.829 5.829 0 0016 7.667zm0 7.917a2.084 2.084 0 11.002-4.169A2.084 2.084 0 0116 15.584z",
    fill: "#000",
    fillOpacity: 0.5
  })));
};
export default SvgUpdateLocation;